import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutProjectComponent } from './components/about-project/about-project.component';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { AnnouncementDetailComponent } from './components/announcement-detail/announcement-detail.component';
import { AnnouncementComponent } from './components/announcement/announcement.component';
import { UpsertAnnouncementComponent } from './components/announcement/upsert-announcement/upsert-announcement.component';
import { ApplicationListComponent } from './components/application-list/application-list.component';
import { ApplyForEventComponent } from './components/apply-for-event/apply-for-event.component';
import { EventCategoryComponent } from './components/event-category/event-category.component';
import { UpsertEventCategoryComponent } from './components/event-category/upsert-event-category/upsert-event-category.component';
import { CreateEventPropertyComponent } from './components/event-property/create-event-property/create-event-property.component';
import { EventPropertyComponent } from './components/event-property/event-property.component';
import { UpdateEventPropertyComponent } from './components/event-property/update-event-property/update-event-property.component';
import { EventComponent } from './components/event/event.component';
import { UpsertEventComponent } from './components/event/upsert-event/upsert-event.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { HomeComponent } from './components/home/home.component';
import { JudgeFormListComponent } from './components/judge-form-list/judge-form-list.component';
import { JudgeFormComponent } from './components/judge-form/judge-form.component';
import { KvkkComponent } from './components/kvkk/kvkk.component';
import { LoginComponent } from './components/login/login.component';
import { MyAnnouncementsComponent } from './components/my-announcements/my-announcements.component';
import { MyApplicationListComponent } from './components/my-application-list/my-application-list.component';
import { MyEducationListComponent } from './components/my-education-list/my-education-list.component';
import { MyEventsComponent } from './components/my-events/my-events.component';
import { MyProfessionListComponent } from './components/my-profession-list/my-profession-list.component';
import { UpsertProfessionComponent } from './components/my-profession-list/upsert-profession/upsert-profession.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { GetMyRequestComponent } from './components/my-requests/get-my-request/get-my-request.component';
import { InsertRequestComponent } from './components/my-requests/insert-request/insert-request.component';
import { MyRequestsComponent } from './components/my-requests/my-requests.component';
import { RefereeFormListComponent } from './components/referee-form-list/referee-form-list.component';
import { RefereeFormComponent } from './components/referee-form/referee-form.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UpsertRoleComponent } from './components/roles/components/upsert-role/upsert-role.component';
import { RolesComponent } from './components/roles/roles.component';
import { TermsAndUsageComponent } from './components/terms-and-usage/terms-and-usage.component';
import { UpdateMyBasicInformationComponent } from './components/update-my-basic-information/update-my-basic-information.component';
import { UpdateMyPasswordComponent } from './components/update-my-password/update-my-password.component';
import { UpdateMyRoleSettingsComponent } from './components/update-my-role-settings/update-my-role-settings.component';
import { UpgradeUserComponent } from './components/upgrade-user/upgrade-user.component';
import { UpsertEducationInfoComponent } from './components/upsert-education-info/upsert-education-info.component';
import { UserRequestDetailComponent } from './components/user-request-list/user-request-detail/user-request-detail.component';
import { UserRequestListComponent } from './components/user-request-list/user-request-list.component';
import { UpsertUserComponent } from './components/users/components/upsert-user/upsert-user.component';
import { UsersComponent } from './components/users/users.component';
import { ViewProfileComponent } from './components/view-profile/view-profile.component';
import { UpsertVolunteerCategoryComponent } from './components/volunteer-category/upsert-volunteer-category/upsert-volunteer-category.component';
import { VolunteerCategoryComponent } from './components/volunteer-category/volunteer-category.component';
import { UpsertVolunteerRoleTypeComponent } from './components/volunteer-role-type/upsert-volunteer-role-type/upsert-volunteer-role-type.component';
import { VolunteerRoleTypeComponent } from './components/volunteer-role-type/volunteer-role-type.component';
import { VolunteerComponent } from './components/volunteer/volunteer.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';


const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["userOperations"]
        }
      },
      {
        path: 'users/new',
        component: UpsertUserComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["userOperations"]
        }
      },
      {
        path: 'users/detail/:id',
        component: UpsertUserComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["userOperations"]
        }
      },
      {
        path: 'roles',
        component: RolesComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["roleOperations"]
        }
      },
      {
        path: 'roles/new',
        component: UpsertRoleComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["roleOperations"]
        }
      },
      {
        path: 'roles/detail/:id',
        component: UpsertRoleComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["roleOperations"]
        }
      },
      {
        path: 'event-categories',
        component: EventCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventCategoryOperations"]
        }
      },
      {
        path: 'event-categories/new',
        component: UpsertEventCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventCategoryOperations"]
        }
      },
      {
        path: 'event-categories/detail/:id',
        component: UpsertEventCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventCategoryOperations"]
        }
      },
      {
        path: 'volunteer-categories',
        component: VolunteerCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'volunteer-categories/new',
        component: UpsertVolunteerCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'volunteer-categories/detail/:id',
        component: UpsertVolunteerCategoryComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'volunteer-role-types/:id',
        component: VolunteerRoleTypeComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'volunteer-role-type/new',
        component: UpsertVolunteerRoleTypeComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'volunteer-role-type/detail/:id',
        component: UpsertVolunteerRoleTypeComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true
        }
      },
      {
        path: 'my-profile',
        component: MyProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'event-list',
        component: EventComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewEvent"]
        }
      },
      {
        path: 'event-list/new',
        component: UpsertEventComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventOperations"]
        }
      },
      {
        path: 'event-list/detail/:id',
        component: UpsertEventComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventOperations"]
        }
      },
      {
        path: 'event-property-list/:id',
        component: EventPropertyComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventOperations"]
        }
      },
      {
        path: 'event-property-list/new/:id',
        component: CreateEventPropertyComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventOperations"]
        }
      },
      {
        path: 'event-property-list/update/:id',
        component: UpdateEventPropertyComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["eventOperations"]
        }
      },
      {
        path: 'application-list/:id',
        component: ApplicationListComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewApplication"]
        }
      },
      {
        path: 'announcement-list',
        component: AnnouncementComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["announcementOperations"]
        }
      },
      {
        path: 'announcement-list/new',
        component: UpsertAnnouncementComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["announcementOperations"]
        }
      },
      {
        path: 'announcement-list/detail/:id',
        component: UpsertAnnouncementComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["announcementOperations"]
        }
      },
      {
        path: 'judge-form-list',
        component: JudgeFormListComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewJudgeForms"]
        }
      },
      {
        path: 'referee-form-list',
        component: RefereeFormListComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewRefereeForms"]
        }
      },
      {
        path: 'update-my-basic-information',
        component: UpdateMyBasicInformationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'update-my-role-settings',
        component: UpdateMyRoleSettingsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'update-my-password',
        component: UpdateMyPasswordComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-education-list',
        component: MyEducationListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'education-info/new',
        component: UpsertEducationInfoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'education-info/detail/:id',
        component: UpsertEducationInfoComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-profession-list',
        component: MyProfessionListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-application-list',
        component: MyApplicationListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'profession/new',
        component: UpsertProfessionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'judge-form',
        component: JudgeFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'referee-form',
        component: RefereeFormComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'profession/detail/:id',
        component: UpsertProfessionComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-requests',
        component: MyRequestsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-requests/new',
        component: InsertRequestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-requests/detail/:id',
        component: GetMyRequestComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'user-request-list',
        component: UserRequestListComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewSupportTickets"]
        }
      },
      {
        path: 'user-request-detail/:id',
        component: UserRequestDetailComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewSupportTickets"]
        }
      },
      {
        path: 'volunteer-list',
        component: VolunteerComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewVolunteerList"]
        }
      },
      {
        path: 'my-announcements',
        component: MyAnnouncementsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'announcement-detail/:id',
        component: AnnouncementDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'my-events',
        component: MyEventsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'apply-for-event/:id',
        component: ApplyForEventComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'view-profile/:id',
        component: ViewProfileComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["viewVolunteerDetails"]
        }
      }
      ,
      {
        path: 'upgrade-user/:id',
        component: UpgradeUserComponent,
        canActivate: [AuthGuard],
        data: {
          admin: true,
          permittedRoles: ["roleUpgradeOperations"]
        }
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'reset-password/:id',
    component: ResetPasswordComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent
  },
  {
    path: 'activate-account/:id',
    component: ActivateAccountComponent
  },
  {
    path: 'kvkk',
    component: KvkkComponent
  },
  {
    path: 'terms-and-usage',
    component: TermsAndUsageComponent
  },
  {
    path: 'about-project',
    component: AboutProjectComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
